import { errorFromResponse } from '../src/common/general-utils';
import { executeActionFlowWithVariableOnly } from '../src/features/action-flows/service/action-flow-service';
import { i18n } from './i18n.client';

export default defineNuxtPlugin(() => {
  // window.json = Vue.prototype.json;
  // This will make old sofy hide the progress loader section
  window.localStorage.fromNewSofy = true;
  window.WIDGETLISTENERS = {};
  window.GET_ACTION_FLOW_DETAILS = async function (UUID, inputVariables, callback) {
    callback(await executeActionFlowWithVariableOnly(UUID, inputVariables));
  };
  return {
    provide: {
      $errorFromResponse: errorFromResponse(i18n.global.t.bind(i18n))
    }
  };
});
